/* Load Modules */
import { memoize } from "lodash";

/* Load Utils */
import buildFormGridFields from "../../../../../../../utils/forms/builders/build-form-grid-fields";
import buildSchemaCompliantDefinition from "../../../../../../../utils/forms/builders/build-schema-compliant-definition";

/* Load Components */
import { SubFormDefinition } from "../../../../../../../utils/forms/components/FormSet";
import getSelectableCoins from "../../../../Utils/GetSelectableCoins/get-selectable-coins";
import getPhilippinesGames from "../../../../Utils/find-ph-fbm-games";
import {
    globalJackpotFormDefinition,
    SCHEMA_NAMES
} from "./GlobalJackpotConfigurationSection.constants";
import { FormBox } from "../../../../../../../utils/forms/components/FormBoxes";

/* Load Defaults */
import { defaultsGlobalJackpot } from "./GlobalJackpotConfigurationSection.defaults";

export const globalJackpotBox = props =>
    memoize(({ gameInstances, schema, globalJackpotConfig }): FormBox[] => {
        const gamesPh = getPhilippinesGames(
            gameInstances,
            schema.properties.game_groups
        );
        const formDefinition = buildSchemaCompliantDefinition(
            schema,
            globalJackpotFormDefinition(gamesPh, getSelectableCoins(props))
        );

        return [
            {
                fields: buildFormGridFields(schema, formDefinition),
                columnClass: "col-12"
            }
        ];
    });
